<template>
    <div class="page">
        <van-icon name="arrow-left" class="return" size="28" @click="goBack" />
        <div class="logo">
            <img src="../assets/images/logo/logo1.png" alt="" />
        </div>
        <div class="sub-logo"></div>
        <div class="info">
            <div class="sub-title">酒店导航指引</div>
            <div class="map">
                <img src="../assets/images/service/map.png" alt="" class="responsive-map" @click="openAmap" />
            </div>
            <div class="desc">地点：武汉富力万达嘉华酒店（三楼大宴会厅）</div>
            <div class="desc">地址：湖北省武汉市武昌区水果湖街东湖路105号</div>
            <!-- <div class="qrCode">
                <img src="../assets/images/qr_code.jpg" alt="">
            </div> -->
            <!-- <div class="text">扫码预定</div> -->
            <!-- <div class="text">酒店预订电话: 027-84756666 / 龚经理 13554490078</div> -->
            <!-- <div class="apply" @click="telPhone">立即联系</div> -->
        </div>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();
const goBack = () => {
    router.back();
};
const openAmap = () => {
    const latitude = 30.552371;// 目标纬度
    const longitude = 114.346005; // 目标经度
    const name = "武汉富力万达嘉华酒店"; // 目标位置名称
    const amapUrl = `https://uri.amap.com/marker?position=${longitude},${latitude}&name=${encodeURIComponent(name)}&src=yourAppName&coordinate=gaode&callnative=1`;
    window.location.href = amapUrl;
};


// const openAmap = () => {
//   const lng = 114.346005; // 经度
//   const lat = 30.552371;  // 纬度
//   const targetName = '武汉富力万达嘉华酒店';
//   const url = `https://map.qq.com/?ref=wh_unicom_demo&to=${encodeURIComponent(targetName)}&tocoord=${lng},${lat}&type=nav`;
//   // 当前页跳转
//   window.location.href = url;
// }



// const telPhone = () => {
//     const phoneNumber = "13554490078"; // 要拨打的电话号码
//     window.location.href = `tel:${phoneNumber}`;
// };


</script>

<style scoped>
.page {
    width: 100vw;
    min-height: 100vh;
    /* 使用 min-height 代替 height */
    background: url("../assets/bg/718.jpg") 100% 100% no-repeat;
    background-size: cover;
    background-attachment: fixed;
    /* 固定背景 */
}

.return {
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
}

.logo img {
	width: 40%;
	height: auto;
	display: block;
    margin: auto;
	padding: 10px 0;
	/* margin-left: 10%; */
}

.sub-logo {
    width: 90%;
    height: 70px;
    background: url("../assets/images/logo/text.png") no-repeat center center;
    background-size: contain;
    margin: auto;
}

.sub-title {
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    margin-bottom: 10px;
}

.info {
    width: 82%;
    margin: auto;
    border-radius: 15px;
    margin-top: 20px;
    padding: 20px 10px;
    background: linear-gradient(180deg, #00b4ff, rgba(0, 123, 255, 0.3));
    /* background-color: rgb(2 174 250 / 20%); */
}

.text {
    color: #ffffff;
    text-align: center;
    margin: 5px 0;
    font-size: 14px;
    font-weight: bold;
    margin-top: 40px;
}

.desc {
    color: #ffffff;
    text-align: center;
    margin: 3px 0;
    font-size: 13px;
}

.responsive-map {
    width: 100%;
    height: auto;
    border-radius: 15px;
}

.qrCode {
    display: flex;
    margin-top: 10px;
}

.qrCode img {
    width: 80px;
    height: auto;
    margin: 0 auto;
}

.apply {
    width: 150px;
    height: 40px;
    /* height: auto; */
    background-image: url("../assets/images/apply.png");
    /* 替换为你的背景图片路径 */
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: auto;
    margin-top: 15px;
    color: #071beb;
    font-weight: bold;
}
</style>
